import { SVGProps } from "react";

export const EnjoymentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.6079 11.3823H11.8511M11.6079 11.6256H11.8511M12.0538 11.504C12.0538 11.6831 11.9086 11.8282 11.7296 11.8282C11.5505 11.8282 11.4053 11.6831 11.4053 11.504C11.4053 11.3249 11.5505 11.1797 11.7296 11.1797C11.9086 11.1797 12.0538 11.3249 12.0538 11.504Z"
      fill="none"
      strokeWidth="1.7295"
      strokeLinecap="round"
    />
    <path
      d="M16.1479 11.3823H16.3911M16.1479 11.6256H16.3911M16.5939 11.504C16.5939 11.6831 16.4487 11.8282 16.2696 11.8282C16.0905 11.8282 15.9453 11.6831 15.9453 11.504C15.9453 11.3249 16.0905 11.1797 16.2696 11.1797C16.4487 11.1797 16.5939 11.3249 16.5939 11.504Z"
      fill="none"
      strokeWidth="1.7295"
      strokeLinecap="round"
    />
    <path
      d="M10.7568 15.7188C11.0271 16.3673 12.054 17.6644 13.9996 17.6644C15.9453 17.6644 16.9722 16.3673 17.2425 15.7188"
      fill="none"
      strokeWidth="1.7295"
      strokeLinecap="round"
    />
    <path
      d="M13.9994 20.909C17.9395 20.909 21.1336 17.7149 21.1336 13.7748C21.1336 9.83471 17.9395 6.64062 13.9994 6.64062C10.0593 6.64062 6.86523 9.83471 6.86523 13.7748C6.86523 17.7149 10.0593 20.909 13.9994 20.909Z"
      fill="none"
      strokeWidth="1.7295"
      strokeLinecap="round"
    />
  </svg>
);
